<template>
    <div v-bind:class="ContentBlockBaseProps.Class" v-bind:style="ContentBlockBaseProps.Style">
        <div :class="BlockProps.Shadow? 'shadow-sm mb-3' : ''" :style="{'background-color' : BlockProps.BGColor + ' !important'}">
            <div class="container" v-bind:style="ContainerPadding">

                <div class="overflow-hidden">
                    <div class="text-center">
                        <div class="row">
                            <div class="col-md-12 h2 text-muted mb-5">
                                <omnieditor :iseditmode="iseditmode" editortype="tinymce" keyDown v-model="BlockProps.LeadIn" tag-name="span" :init="EditorConfig" />
                            </div>
                        </div>
                        <div class="row" v-if="ApostilleConfig.offerExpressService">
                            <div class="col-md-12 h2 text-muted" style="margin-bottom:0">
                                <h4 style="margin-bottom:0;color:steelblue"><span class="text-default"><i class="bi bi-envelope"></i> STANDARD SERVICE<sup>*</sup> </span></h4>
                            </div>
                        </div>
                        <div class="row" style="padding: 10px;">
                            <div class="col-12 col-sm-6 mb-md-0" v-bind:class="BlockProps.Shadows? 'shadow-lg' : ''">
                                <h4 class="text-default">First Document<br /></h4>
                                <span class="display-4" style="color:steelblue">
                                    ${{ApostilleConfig.basicFee.toString().toSmartFixed(2)}}
                                </span>
                                <p class="text-muted">includes return shipping</p>
                            </div>
                            <!-- End Col -->

                            <div class="col-12 col-sm-6 mb-md-0" v-bind:class="BlockProps.Shadows? 'shadow-lg' : ''">
                                <h4 class="text-default">Additional Documents<br /></h4>
                                <span class="display-4" style="color:steelblue">${{ApostilleConfig.basicFeeAdditionalDocument.toString().toSmartFixed(2)}} each</span>
                                <p class="text-muted">includes return shipping</p>
                            </div>
                            <!-- End Col -->

                        </div>
                        <div class="row">
                            <div class="col-md-12 text-muted small fst-italic" style="margin-bottom:0">
                                *{{ApostilleConfig.standardDeliveryTerms}}
                            </div>
                        </div>
                        <div class="row" style="padding:10px;" v-if="ApostilleConfig.offerExpressService">
                            <div class="col-12">
                                <hr style="padding:0px;" />
                            </div>
                        </div>
                        <div class="row" v-if="ApostilleConfig.offerExpressService">
                            <div class="col-md-12 h2 text-muted" style="margin-bottom:0">
                                <h4 style="margin-bottom:0" class="text-primary"><span><i class="bi bi-airplane-engines"></i> EXPEDITED SERVICE<sup>*</sup></span></h4>
                            </div>
                        </div>
                        <div class="row" style="padding:10px; margin-top:10px;" v-if="ApostilleConfig.offerExpressService">
                            <div class="col-12 col-sm-6 mb-md-0" v-bind:class="BlockProps.Shadows? 'shadow-lg' : ''">
                                <h4 class="text-primary">First Document</h4>
                                <span class="display-4" style="color:limegreen">
                                    ${{ApostilleConfig.expeditedFee.toString().toSmartFixed(2)}}
                                </span>
                                <p class="text-muted">includes return shipping</p>
                            </div>
                            <!-- End Col -->

                            <div class="col-12 col-sm-6 mb-md-0" v-bind:class="BlockProps.Shadows? 'shadow-lg' : ''">
                                <h4 class="text-primary">Additional Documents</h4>
                                <span class="display-4" style="color:limegreen">${{ApostilleConfig.expeditedFeeAdditionalDocument.toString().toSmartFixed(2)}} each</span>
                                <p class="text-muted">includes return shipping</p>
                            </div>
                            <!-- End Col -->

                        </div>
                        <div class="row" v-if="ApostilleConfig.offerExpressService">
                            <div class="col-md-12 text-muted small fst-italic" style="margin-bottom:0">
                                *{{ApostilleConfig.expressDeliveryTerms}}
                            </div>
                        </div>
                        <!-- End Row -->
                        <div class="row mt-5">
                            <div class="col-md-12">
                                <omnieditor :iseditmode="iseditmode" editortype="tinymce" keyDown v-model="BlockProps.Content" tag-name="div" :init="EditorConfig" />

                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>

        <div v-if="iseditmode" style="z-index:300" class="modal" :id="'editor' + BlockProps.UId" tabindex="-1" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
            <div class="modal-dialog modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">Options</h5>
                    </div>
                    <div class="modal-body">
                        <hr style="margin: 0px; margin-bottom:10px;" />
                        <propertybaseeditors :blockprops="BlockProps" :additionalcfg="AdditionalCfg"></propertybaseeditors>
                        <propertytogglededitor propertyname="Shadows" :blockprops="BlockProps" prompt="Inner Drop Shadows"></propertytogglededitor>

                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-sm btn-secondary" data-bs-dismiss="modal">Done</button>
                        <!--<button type="button" class="btn btn-sm btn-primary">Save changes</button>-->
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    import EventHub from '/src/Util/EventHub.js';
    import ContentBlockBase from '/src/components/ContentCreator/ContentBlockBase.vue'
    import { computed, ref, nextTick } from 'vue'


    export default {
        inheritAttrs: false,
        name: 'ApostillePricing',
        mixins: [ContentBlockBase],
        props: ['apostilleconfig'],
        components: {
        },
        computed:
        {
            ApostilleConfig: function () {
                var x = this.Store.TenantConfig;
                if (this.apostilleconfig) {
                    return this.apostilleconfig
                }

                if (this.Store && this.Store.TenantConfig && this.Store.TenantConfig.serviceConfigApostille) {
                    return this.Store.TenantConfig.serviceConfigApostille;
                }               
            }
        },
        data() {
            return {     
                AdditionalCfg: 'https://admin.notarylaunchpad.com/home/sitesettings#ApostilleSettings'
            };
        },
        methods:
        {
         
            EditProperties: function () {
                var id = '#editor' + this.BlockProps.UId;
                var modalEl = document.querySelector(id);
                if (modalEl == null) {
                    return;
                }
                var modal = bootstrap.Modal.getOrCreateInstance(modalEl); // Returns a Bootstrap modal instance
                modal.show();
            },
        },

        setup(props, context)
        {             
            return {} 
        },
        created()
        {           
        },
        beforeUnmount()
        {
        },
        mounted() {
            nextTick().then(() => {
      
            });
        }
    }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
   
</style>

